import React, {useCallback, useState} from 'react';
import HomeSideBonus from './home-side-bonus';
import HomeChat from './home-chat';
import {useLogin} from '@/utils/state-hooks';
import {useFocusEffect} from '@react-navigation/native';
import {getTaskCount} from '@/pages/promotions/service';
import {goTo} from '@/utils';
import HomeSideCheck from './home-side-check';

interface HomeSideProps {
  hasService?: boolean;
  chatImg?: string;
}

const HomeSide = ({hasService}: HomeSideProps) => {
  const login = useLogin();
  const [taskCount, setTaskCount] = useState(0);
  useFocusEffect(
    useCallback(() => {
      if (!login) {
        return;
      }
      getTaskCount().then(data => {
        setTaskCount(data);
      });
    }, [login]),
  );
  return (
    <div className="absolute bottom-[56px] right-[1.375rem] z-10 flex flex-col items-center">
      <HomeSideCheck />
      <HomeSideBonus
        count={taskCount}
        onClick={() => goTo('PromotionsV2', {tabKey: 'promotion'})}
      />
      {!!hasService && <HomeChat />}
    </div>
  );
};

export default HomeSide;
